<template>
<div>
    <el-form-item
        v-for="(item, index) in value"
        :key="index">
        <el-col :xs="20" :sm="22">
        	<slot :item="item"></slot>
        </el-col>
        <el-col :xs="4" :sm="2">
            <el-button @click.prevent="removeItem(item)" size="mini">X</el-button>
        </el-col>
    </el-form-item>
    <el-row>
        <el-col :xs="24">
            <el-button @click.prevent="addItem()" icon="el-icon-plus" size="mini">{{buttonText}}</el-button>
        </el-col>
    </el-row>
</div>
</template>

<script>
    export default {
    	props: {
            'value': {
                type: Array,
                default: () => []
            },
            'buttonText': String,
            'default': {
                type: Object,
                default: () => {}
            }
        },
        data() {
            return {
            	// items: this.value
            }
        },
        watch: {
        	'items': function(to) {
                // console.log('watch items', to);
        		this.$emit('input', to);
        	}
        },
        methods: {
            removeItem(item) {
                let items = this.value;
                let index = items.indexOf(item);
                if (index !== -1) {
                    items.splice(index, 1);
                    this.$emit('input', items);
                }
            },
            addItem() {
                // console.log(this.$refs);
                // this.$refs.crud.addShift();
                let items = this.value;
                if (items == null) {
                    items = [];
                }
                items.push(JSON.parse(JSON.stringify(this.default)));
                this.$emit('input', items);
                // this.$forceUpdate();
            }
        }
    }
</script>